// removed by extract-text-webpack-plugin
module.exports = {"bid-status":"bid-status___35hUA","leading":"leading___1Fl87","warning":"warning___3BOCD","pending":"pending___Scm9Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/CardStatusBanner.scss
// module id = Qv2C
// module chunks = 46